import React from "react";
import { NavLink } from "react-router-dom";
import footerLogo from "../../assets/images/footerLogo.png";
import termsAndConditionIcon from "../../assets/images/terms&condition.png";

const Footer = ({ t }) => {
  return (
    <div className="bg-primary text-white pb-6 p-6 w-full relative bottom-0">
      <div className="flex">
        <img src={footerLogo} alt="" className="h-[20px] w-[20px]" />
        <div className="text-[16px] font-semibold ms-2">{t("storiesForLife")}</div>
      </div>
      <hr className="mt-6 mb-6" />
      <div className="flex">
        <div>
          <img src={termsAndConditionIcon} alt="" className="mt-1" />
        </div>
        <NavLink to="/termandcondtion" target="_blank">
          <div className="text-[16px] font-semibold ms-2">{t("termsAndConditions")}</div>
        </NavLink>
      </div>
      <div className="flex mt-4">
        <div>
          <img src={termsAndConditionIcon} alt="" className="mt-1" />
        </div>
        <NavLink to="/privacypolicy" target="_blank">
          <div className="text-[16px] font-semibold ms-2">{t("privacyPolicy")}</div>
        </NavLink>
      </div>
    </div>
  );
};

export default Footer;
